/** @format */
import modelOptions from './modelOptions';
import getAccess from './getAccess';
import dataUtils from './dataUtils';

export default {
  mixins: [modelOptions, getAccess, dataUtils],
  data() {
    return {
      fieldsF: '',
    };
  },
  methods: {
    doWatch(e) {},
    replaceFields(model, fieldsReplace = {}) {
      if (fieldsReplace) {
        Object.keys(fieldsReplace).forEach((f) => {
          let idx = model.findIndex((el) => {
            return el.name == f;
          });
          if (idx !== -1) {
            const c = fieldsReplace[f];
            if (c?._type === 'over') {
              model[idx] = c;
            } else if (c?._type === 'join') {
              model[idx] = Object.assign({}, model[idx], c);
            } else model[idx] = c;
          } else model.push(Object.assign({}, fieldsReplace[f]));
        });
      }
      return model;
    },
    getModelByName(n) {
      return this.model.find((m) => m.name == n) || {};
    },
    generateModel(type, viewName) {
      let r = [];
      let view = this.getConfigView(viewName);
      if (!view.model) return console.log('not find', viewName);
      let dataModel = this.getConfigModel(view.model);
      let dataView = view[type].data;
      for (let i = 0; i < dataView.length; i++) {
        let el = dataView[i];
        let a = { ...el, ...dataModel[el.name] };
        r.push(a);
      }
      return r;
    },
    getConfigModel(name) {
      return this.$root.config.meta.models[name].data;
    },
    getConfigView(name) {
      return this.$root.config.meta.views[name];
    },
    checkModelAccess(el, def = true) {
      const role = this.$root.profile.role;
      const user = this.$root.profile.id;
      let res = def;
      if (el?.access) {
        let access = el.access;
        let r = access?.role;
        let u = access?.user;

        if (!r) return res;
        // let role = this.$root.profile.role;
        if (typeof r === 'string') {
          try {
            res = eval('(' + r + ' ) ');
          } catch (error) {
            console.error(error);
          }
        } else if (typeof r === 'object' && Array.isArray(r)) {
          if (r.length) {
            res = r.includes(role) || false;
            if (!res) {
              res = r.includes(-1) && !r.includes(-role) && !(u && u.includes(-user));
            }
          }
        }
      }
      return res;
    },
    getModelList(m, list = 'list', filter = false) {
      if (!m) return [];
      if (m[list + `_role${this.$root.profile.role}`]) list = list + `_role${this.$root.profile.role}`;
      const model = JSON.parse(JSON.stringify(m[list])) || [];
      //const model = [...m[list]];
      model.forEach((el) => {
        if (!el.hasOwnProperty('style')) {
          el.style = 'white-space: normal;';
        }
        if (el?.isDisableFunc) {
          if (typeof el.isDisableFunc === 'string') {
            el.isDisableFunc = eval(el.isDisableFunc);
          }
        }
        if (!this.checkModelAccess(el)) el.hidden = true;

        if (el.options) {
          el.options = this.getOptions(el);
        }
        if (el?.sourceList) {
          let mm;
          if (typeof el.sourceList == 'string' && el.sourceList.includes('config.')) {
            mm = this.getObjectPath(this.$store.getters['config/get'] || {}, el.sourceList);
          } else mm = m?.[el.sourceList] || this.m?.[el.sourceList];
          let opts = [];
          if (filter) {
            opts = mm
              ? mm.filter((l) => {
                  return !l?.hidden;
                })
              : [];
          } else {
            opts = mm;
          }
          delete el.sourceList;
          el.options = [...(opts || [])];
        }
      });
      //console.log(model, m);
      return model;
    },
    getObjectPath__(o, path) {
      const p = path.split('.');
      let tmp;
      for (let i = 0; i < p.length; i++) {
        const el = p[i];
        if (i === 0) {
          tmp = JSON.parse(JSON.stringify(o || {}));
        }
        tmp = tmp?.[el];
      }
      return tmp;
    },
    calcModel(type, template = 'form', config = null) {
      const mt = Object.assign({}, this.m);
      let modelT = this.getModelList(mt, template, true);
      let source = mt;
      source = this.getObjectPath(source, type) || source;
      //console.log('source', source, modelT);
      const fields = (source?.fields || '').split(',');
      let fieldsRO = (source?.fieldsRO || '').split(',');
      if (this.data?.status == 2 && source?.setAutoReadonly !== false) fieldsRO = fields;
      const fieldsForm = (source?.fieldsForm || '').split(',');
      let model = [];
      modelT = this.replaceFields(modelT, source?.fieldsReplace);
      for (const f of fields) {
        let key = f.replace(/^\*+/, '');
        let mm = modelT.find((m) => {
          return m.name == key;
        });

        if (mm && this.checkModelAccess(mm)) {
          if (f.startsWith('*')) mm.showNull = true;
          model.push(mm);
        }
      }

      model.forEach((el) => {
        if (fieldsRO.includes(el.name)) {
          el.readonly = true;
        }
        if (el?.roleShow) {
          //!el.roleShow.includes(this.$root.profile.role)
          el.hidden = !this.checkAccess({ role: el.roleShow }, null, this.$root.profile.role, this.$root.profile.id, true);
          // console.log(el.name, el.hidden, el.roleShow);
        }
      });
      let mForm = [];
      fieldsForm.forEach((field) => {
        let f = field.split('#');
        mForm.push({ name: f[0], size: f[1] || 12 });
      });
      if (fieldsForm) this[type] = mForm;
      return model;
    },

    calcModelConfig(config_, m_ = this.m) {
      const getFields = (f) => {
        if (Array.isArray(f)) return f.join(',');
        else return f;
      };
      let config = Object.assign({}, config_);
      this['modelForm'] = null;
      const mt = Object.assign({}, m_);
      let modelT = this.getModelList(mt, 'form', !true);
      config.fields = config?.fields || modelT.map((m) => m.name).join(',');
      config.fieldsRO = config?.fieldsRO || '';
      config.fieldsForm = config?.fieldsForm || modelT.map((m) => m.name + '#' + (m?.size || 12)).join(',');
      let fields = (getFields(config.fields).replace(' ', '').replace(/\s/g, '') || '').split(',');
      let fieldsRO = (getFields(config.fieldsRO).replace(' ', '').replace(/\s/g, '') || '').split(',');
      if (this.$root.profile.role == 1000) {
        if (this.$route.query.root) fieldsRO = '';
      }
      let fieldsForm = (getFields(config.fieldsForm).replace(' ', '').replace(/\s/g, '') || '').split(',');
      let model = [];
      for (const f of fields) {
        if (f) {
          let m = modelT.find((m) => {
            return m.name == f;
          });
          if (m) {
            model.push(m);
          } else {
            //m['hidden'] = true;
            // model.push(m);
          }
        }
      }
      model = this.replaceFields(model, config?.fieldsReplace);

      let mForm = [];
      fieldsForm.forEach((field) => {
        let f = field.split('#');
        mForm.push({ name: f[0], size: f[1] || 12 });
      });
      model.forEach((el) => {
        if (fieldsRO.includes(el.name)) {
          el.readonly = true;
        }
        if (el?.roleShow && !el.roleShow.includes(this.$root.profile.role)) {
          el.hidden = true;
        }
        if (!this.id && el?.hiddenCreate) {
          el.hidden = true;
        }
        let e = mForm.find((f) => f.name == el.name);
        //el.size = e?.size || 12;
        el.size = mForm.find((f) => f.name === el.name)?.size || e?.size || 12;
        if (!el?.hidden) el.hidden = e ? false : true;
      });

      this['modelForm'] = mForm;
      return model;
    },
  },
};
